import { useEffect, useState, useContext } from 'react';
import Box from '../../shared/layouts/Box';
import Stack from '../../shared/layouts/Stack';
import Button from '../../shared/Button';
import WithIcon from '../../shared/layouts/WithIcon';
import Flex from '../../shared/layouts/Flex';
import LoginContainer from './LoginContainer';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import WhiteLabelContext from "../../../context/WhiteLabelContext";
import {useTranslation} from "react-i18next";
import useIconLibrary from "../../../hooks/useIconLibrary";

const SwitchMfa = () => {
  const navigate = useNavigate();
  const { platformName } = useContext(WhiteLabelContext);
  const [multifactorTypes, setmultifactorTypes] = useState([]);
  const { t } = useTranslation();
  const { EditIcon, ShieldIcon } = useIconLibrary();

  useEffect(() => {
    axios
      .get('multifactor/change')
      .then((res) => {
        setmultifactorTypes(res.data.types);
      })
      .catch((err) => console.error(err));
  }, []);

  return (
    <LoginContainer width={{ sm: '21.5rem', ml: '27.5rem'}} hideUwKluisLogo>
      <Box px="xl" py="2xl" flex="1">
        <Stack space="l">
          <Box fontScale="xl" fontWeight="bold">
            {t('Op welke manier wil je inloggen?')}
          </Box>
          <Box>
            {t(
              'Kies uit een van de andere opties die je hebt ingesteld in {{platformName}} om in te loggen.',
              {platformName}
            )}
          </Box>
          <Button
            variant="symantic"
            width="100%"
            css={(theme) => ({
              border: `2px solid ${theme.colors.secondaryFont}`,
              padding: theme.space.m,
              display: 'flex',
              justifyContent: 'flex-start',
              marginTop: theme.space.l,
              '&:hover': {
                borderColor: theme.colors.primary,
                color: theme.colors.primary,
                background: theme.colors.primaryBackground,
                'svg path': { fill: theme.colors.primary },
              },
            })}
            onClick={() => {
              navigate('/mfa');
            }}
          >
            <WithIcon>
              <ShieldIcon width="32px" height="32px" />
              {t('Gebruik de authenticatie-app')}
            </WithIcon>
          </Button>
          {multifactorTypes.some(({ type }) => type === 'recovery-codes') && (
          <Button
            variant="symantic"
            width="100%"
            css={(theme) => ({
              border: `2px solid ${theme.colors.secondaryFont}`,
              padding: theme.space.m,
              display: 'flex',
              justifyContent: 'flex-start',
              marginTop: theme.space.m,
              '&:hover': {
                borderColor: theme.colors.primary,
                color: theme.colors.primary,
                background: theme.colors.primaryBackground,
                'svg path': { fill: theme.colors.primary },
              },
            })}
            onClick={() => {
              navigate('/recovery-code');
            }}
          >
            <WithIcon>
              <EditIcon width="32px" height="32px" />
              {t('Gebruik een herstelcode')}
            </WithIcon>
          </Button>
          )}
          <Flex mt="2xl" justifyContent="flex-end">
            <Button
              variant="primary-outline"
              onClick={() => {
                navigate('/mfa');
              }}
            >
              {t('Annuleren')}
            </Button>
          </Flex>
        </Stack>
      </Box>
    </LoginContainer>
  );
};
export default SwitchMfa;
